module.exports = __webpack_public_path__ + "d63f9a09.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/4k.jpg
// module id = 1212
// module chunks = 1 3 4